import React from 'react';
import { TypographyComponent as TypographyElement, Link } from '@tvg/fuse-design';
import styled from 'styled-components';

const Container = styled.div``;

const Title = styled(TypographyElement)`
  margin-bottom: var(--spacing-space8);
`;

const Text = styled(TypographyElement)`
  margin-bottom: var(--spacing-space16);
`;

function WeeInfo(): JSX.Element {
  return (
    <Container data-testid="wee-info-wrapper">
      <Title tag="p" size="1" data-testid="wee-info-title">
        Waste Electrical and Electronic Equipment
      </Title>
      <Text size="m1" tag="p" type="paragraph" data-testid="wee-info-text">
        Waste Electrical and Electronic Equipment (WEEE) and waste batteries must never be placed in your waste disposal
        or recycling bins. WEEE is taken back free of charge at electrical retail outlets on a one-for-one like-for-like
        basis. There is a bin for small batteries in your local store. Local authority civic amenity facilities also
        take back WEEE and waste batteries free of charge. WEEE and waste battery recycling is free.
      </Text>

      <Link
        href="https://www.very.ie/help/en/weee-directive.page"
        data-testid="wee-info-link"
        size="medium"
        target="_blank"
        rel="noopener noreferrer"
      >
        Go to our WEEE policy page to learn more
      </Link>
    </Container>
  );
}

export default WeeInfo;
